import { Badge } from "react-bootstrap";
import { ConceptoVenta } from "../../services/ventasServicios";

function ConceptosVentaBadges({ conceptos }: { conceptos: ConceptoVenta[] }) {
  let conceptosOrdenados = conceptos.sort((servA, servB) =>
    servA.toString().localeCompare(servB.toString())
  );

  return (
    <>
      {conceptosOrdenados.map((concepto) => (
        <Badge
          key={concepto}
          bg={computeBadgeColor(concepto)}
          style={{ margin: "2px" }}
        >
          {computeBadgeLabel(concepto)}
        </Badge>
      ))}
    </>
  );
}

const computeBadgeColor = (concepto: ConceptoVenta) => {
  switch (concepto) {
    case "SERVICIO_GUARDERIA":
      return "primary";
    case "SERVICIO_HOTEL":
      return "secondary";
    case "SERVICIO_ENTRENAMIENTO":
      return "success";
    case "SERVICIO_SPA":
      return "warning";
    case "SERVICIO_TRANSPORTE":
      return "info";
    case "COMPRA":
      return "danger";
    default:
      return "dark";
  }
};

const computeBadgeLabel = (concepto: ConceptoVenta) => {
  switch (concepto) {
    case "SERVICIO_GUARDERIA":
      return "GUAR";
    case "SERVICIO_HOTEL":
      return "HOT";
    case "SERVICIO_ENTRENAMIENTO":
      return "ENTR";
    case "SERVICIO_SPA":
      return "SPA";
    case "SERVICIO_TRANSPORTE":
      return "TRANS";
    case "COMPRA":
      return "COMPRA";
    default:
      return "";
  }
};

export default ConceptosVentaBadges;
